export default __webpack_public_path__ + "static/media/add.b23d65ed.svg";